import type { GroupMemberInfo, GroupMemberRole, User } from '@halo/chat-sdk';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useStaticAppStore } from './useStaticAppStore';

export function useGroupMembers(
  gid: string | undefined,
  role?: GroupMemberRole,
  options?: {
    immediate?: boolean;
  }
) {
  const { immediate = false } = options || {};
  const { client } = useStaticAppStore();
  const [members, setMembers] = useState<(GroupMemberInfo & User)[]>([]);
  const removeEventListenerRef = useRef<() => void>(null);

  const run = useCallback(() => {
    if (client) {
      if (gid) {
        removeEventListenerRef.current?.();
        ({ removeEventListener: removeEventListenerRef.current } =
          client.Api.session.fetchGroupMembers({
            gid,
            role,
            cb: setMembers,
          }));
        return removeEventListenerRef.current;
      } else {
        setMembers([]);
      }
    }
  }, [client, gid, role]);

  const removeEventListener = useCallback(() => {
    removeEventListenerRef.current?.();
  }, []);

  useEffect(() => {
    if (immediate) {
      return run();
    }
  }, [run, immediate]);

  return {
    members,
    run,
    removeEventListener,
  };
}
